var $ = require('jquery');

/**
 * Fits an element to its parent
 * @param $el
 * @param options
 */
var VideoPopups = {
    initialised: false
};

/**
 * Add event listeners
 */
VideoPopups.init = function()
{
    if (this.initialised) {
        return;
    }

    $(document).on('click', '[data-video-popup]', function(e) {
        this.showPopup($(e.currentTarget).data('video-popup'));
    }.bind(this));

    this.initialised = true;
};

/**
 * Update all elements
 */
VideoPopups.showPopup = function(src)
{
    $.magnificPopup.open({
        mainClass: 'mfp-zoom-in mfp-custom',
        fixedContentPos: true,
        autoFocusLast: false,
        items: {
            src: src,
            type: 'iframe'
        }
    });
};

module.exports = VideoPopups;